module.exports = __webpack_public_path__ + "dffa96789e5b50062a299ccba3c52d25.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/logo-b-o_neu.png
// module id = 969
// module chunks = 0